module.exports = __webpack_public_path__ + "img/file-text-blue.6a6e1974.png";